<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('dailyExpense.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('dailyExpense.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="d-flex ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
            <a-range-picker
              v-model="dateRange"
              :ranges="{'This Month': [moment().startOf('M'), moment().endOf('month')] }"
              @change="fetchData()" 
              class="ts-w-64"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
            />
          </div>
          <div class="d-flex">
            <ts-input
              v-tooltip="$t('dailyExpense.search')"
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.exp_date }}</td>
          <td>{{ record.expense_item.category ? record.expense_item.category.exp_category : null }}</td>
          <td>{{ record.expense_item.exp_item }}</td>
          <td class="text-right">{{ record.currency.currency_code + ' ' + $formatNumber(record.exp_unit_price, 2)  }}</td>
          <td class="text-center">{{ record.exp_qty }}</td>
          <td class="text-right">{{ record.currency.currency_code + ' ' + $formatNumber(record.exp_amount, 2) }}</td>
          <td class="text-center">{{ record.fx_rate }}</td>
          <td>{{ record.employee_name_en }}</td>
          <td>{{ record.exp_desc }}</td>
          <td class="text-center ts-space-x-3">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('dailyExpense.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="400px"
      >
        <from-action
          @cancel="clearEdit"
          @fetchData="fetchData"
        />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'
import moment from 'moment'

export default {
  name: 'dailyExpenseIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('expense/dailyExpense', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.expense.dailyExpense.search
      },
      set(newValue) {
        this.$store.commit('expense/dailyExpense/SET_SEARCH', newValue)
        this.$store.commit('expense/dailyExpense/RESET_CURRENT_PAGE')
      }
    },
    dateRange: {
      get() {
        return this.$store.state.expense.dailyExpense.dateRange
      },
      set(newValue) {
        this.$store.commit('expense/dailyExpense/SET_DATE_RANGE', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('dailyExpense.date') },
        { name: this.$t('dailyExpense.category') },
        { name: this.$t('dailyExpense.expenseItem') },
        { name: this.$t('dailyExpense.unitPrice'), style: 'text-align:right' },
        { name: this.$t('dailyExpense.quantity'), style: 'text-align:center' },
        { name: this.$t('dailyExpense.amount'), style: 'text-align:right' },
        { name: this.$t('dailyExpense.fxRate'), style: 'text-align:center' },
        { name: this.$t('dailyExpense.expenseBy') },
        { name: this.$t('dailyExpense.description')},
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    moment,
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('expense/dailyExpense/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('expense/dailyExpense/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit(){
      this.$store.commit('expense/dailyExpense/SET_EDIT_DATA', {})
      this.fetchData()
      this.showForm = false
		},
		deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('expense/dailyExpense/destroy', record.tran_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('expense/dailyExpense/RESET_STATE')
    next()
  }
}
</script>
